import { render, staticRenderFns } from "./WorkshopsItem.vue?vue&type=template&id=08d24a86&scoped=true&"
import script from "./WorkshopsItem.vue?vue&type=script&lang=js&"
export * from "./WorkshopsItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsItem.vue?vue&type=style&index=0&id=08d24a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d24a86",
  null
  
)

component.options.__file = "WorkshopsItem.vue"
export default component.exports